export default __webpack_public_path__ + "static/media/Pdf_no_image.286ac4ee.png";